/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1ArtifactState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ARTIFACT_STATE_ENTITY_NAME = 'ixm.userauth.v1.Artifact';
export const ixmUserauthV1ArtifactStateEntity = new schema.Entity<IxmUserauthV1ArtifactState>(IXM_USERAUTH_V1_ARTIFACT_STATE_ENTITY_NAME, {}, { idAttribute: 'artifactId' });

